import { HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { DiagnosticoCliente } from '../api/dto/diagnostico-cliente';
import { FichaDiagnosticoCliente } from '../api/dto/ficha-diagnostico-cliente';

@Injectable({
    providedIn: 'root',
})
export class DiagnosticoClienteService {

    constructor(private http: HttpClient) { }
    private url: string = UrlServidor.URL_BASE + 'diagnosticos-clientes/';

    listarPorCliente(clienteId?: number): Observable<DiagnosticoCliente[]> {
        return this.http.get<DiagnosticoCliente[]>(this.url + 'cliente/' + clienteId);
    }

    listarFichaDiagnosticoPorCliente(clienteId?: number): Observable<FichaDiagnosticoCliente[]> {
        return this.http.get<FichaDiagnosticoCliente[]>(this.url + 'cliente/' + clienteId + '/ficha');
    }

    salvar(diagnostico: DiagnosticoCliente): Observable<DiagnosticoCliente> {
        return this.http.post<DiagnosticoCliente>(this.url, diagnostico);
    }

    atualizar(id?: number, diagnostico?: DiagnosticoCliente): Observable<DiagnosticoCliente> {
        return this.http.put<DiagnosticoCliente>(this.url + id, diagnostico);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(this.url + id);
    }
}